import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './components/navbar/navbar.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'li-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NavbarComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'li-dance-backoffice';

  hiddenNavbarRoutes = ['/login', '/register'];

  constructor(public router: Router) {}

  get showNavbar(): boolean {
    return !(
      this.router.url.includes('/login') ||
      this.router.url.startsWith('/checkin/') ||
      environment.lite
    );
  }
}
